import { useQuery } from '@tanstack/react-query';

import { DatasetFiltersType } from '../../models/dataset-filters.model';
import { DatasetContentModel } from '../../models/dataset.model';

import API from '../../services/api';

const getFilteredDatasetContent = async (
    datasetId?: number,
    filters?: DatasetFiltersType,
) => {
    if (!datasetId) return null;
    if (!filters || !Object.keys(filters).length) return null;
    const { data } = await API.fetchFilteredDatasetContentById(
        datasetId,
        encodeURIComponent(JSON.stringify(filters)),
    );
    return (data?.items ?? []) as DatasetContentModel[];
};

export default function useDatasetContentFilterQuery(
    datasetId?: number,
    filters?: DatasetFiltersType,
) {
    return useQuery({
        queryKey: ['datasetContent', datasetId, 'filters', filters],
        queryFn: () => getFilteredDatasetContent(datasetId, filters),
        enabled: !!datasetId,
    });
}
